declare const window;
export const propertiesService = window.APP_PROPS || {};
window.APP_CONFIG = propertiesService.APP_CONFIG;
